import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {UsersService} from '../users.service';
import {EventsService} from '../../events/events.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material';
import {BehaviorSubject} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserPermisComponent} from '../user-permis/user-permis.component';
import {UserPassesComponent} from '../user-passes/user-passes.component';
import {UserBraceletsComponent} from '../user-bracelets/user-bracelets.component';
import moment from 'moment';
import {EventAttComponent} from '../event-att/event-att.component';
import {BItemComponent} from './b-item/b-item.component';
import {UserParkingComponent} from '../user-parking/user-parking.component';
import {CropperDialogComponent, dataURLtoFile} from '../../cropper-dialog/cropper-dialog.component';
import * as jwt_decode from 'jwt-decode';
// const urlLogo = 'https://mlsz-defba.firebaseapp.com/assets/media/add_photo.png';
// const url = 'https://mlsz-defba.firebaseapp.com/assets/media/add_photo.png';

const url = '/assets/media/avatar.png';

export interface Events {
	id: string;
	name: string;
}

@Component({
	selector: 'kt-new',
	templateUrl: './new.component.html',
	styleUrls: ['./new.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class NewComponent implements OnInit {
	@ViewChild('imagee', null) imagee: ElementRef;
	availableRoles$ = new BehaviorSubject([]);
	events = new MatTableDataSource<Events>();
	userID;
	url: string | ArrayBuffer = url;
	userDetail: any = {};
	// displayedColumns: string[] = ['checked', 'eventsName', 'pass', 'karszalag'];
	displayedColumns: string[] = ['eventsName', 'item'];
	pageSize = 50;
	page = 1;
	file: File;
	image: string | File = null;
	nev = '';
	collection: number;
	userRoleName = new FormControl();
	rendezesirany = 'asc';
	roleName = new FormControl();
	joggomb: boolean = false;
	permission;
	currentYear = new Date();
	minDate = new Date(1901, 1, 1);
	maxDate = this.currentYear;

	constructor(private changeDetectorRef: ChangeDetectorRef,	private modal: NgbModal, private modalService: NgbModal, private router: Router, private route: ActivatedRoute, private eventService: EventsService, private userService: UsersService, private toastr: ToastrService, private fb: FormBuilder) {
		var blob = null;
		var xhr = new XMLHttpRequest();
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.onload = () => {
			const reader = new FileReader();
			reader.addEventListener('load', () => {
				this.url = reader.result;
			});
			reader.readAsDataURL(xhr.response);
		};
		xhr.send();
	}

	form = this.fb.group({

		email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
		password: ['', Validators.required],
		eventIds: [''],
		roleId: ['', Validators.required],
		firstname: ['', [Validators.required, Validators.pattern('^[a-zÁÉÚŐÓÜÖÍ áéúőóűüöíA-Z_-]{3,15}$')]],
		lastname: ['', [Validators.required, Validators.pattern('^[a-zÁÉÚŐÓÜÖÍáé úőóűüöíA-Z_-]{3,20}$')]],
		birthDate: ['', Validators.required],
		birthPlace: ['', Validators.required],
		motherName: ['', Validators.required],
		nickName: [],
		tutelaryName: []
	});


	ngOnInit() {

		this.userID = this.route.snapshot.paramMap.get('id');
		this.getAvailableRoles();
		this.getData();
	}


	getEvents() {

		this.eventService.getMyEvent().subscribe((res) => {
			this.events.data = res;
		});
	}

	compareRole = (option, selected) => option && selected && option === selected;


	getData() {
		if (this.userID != 'new') {
			const passwordController = this.form.get('password');
			passwordController.setValidators(null);
			this.userService.getUser(this.userID).subscribe((res) => {
				this.userDetail = res;
				this.events.data = res.events;
				console.log(res)
				this.form.setValue({
					email: res.email,
					password: null,
					eventIds: res.events,
					roleId: res.userRole.id,
					firstname: res.firstname,
					lastname: res.lastname,
					// birthDate:  moment(res.birthDate).format('YYYY-MM-DD'),
					birthDate: res.birthDate,
					tutelaryName: res.tutelaryName,
					birthPlace: res.birthPlace,
					motherName: res.motherName,
					nickName: res.nickName
				});
				this.image = res.profileImageLink;
				this.userRoleName.setValue(res.userRole.name);
				this.permission = res.userRole.name;
				if (res.userRole.name == 'SUPERVISOR' || res.userRole.name == 'ALSUPERVISOR') {
					this.setJogosultsagGomb();
				}

				this.userDetail.event = res.eventIds;
				this.form.controls['roleId'].disable();
				this.url = res.profileImageLink;
			});
		}
	}


	onSelectFile(event) {
		const ref = this.modal.open(CropperDialogComponent, {
			ariaLabelledBy: 'modal-basic-title',
			size: 'lg'
		});
		ref.componentInstance.source = event;
		ref.result.then(result => {
			if (result) {
				this.url = result;
				this.image = dataURLtoFile(result, 'file.png');
				this.changeDetectorRef.detectChanges();
			}
		});

	}

	setJogosultsagGomb() {
		const decoded = this.getDecodedAccessToken(localStorage.getItem('token'));
		const role = decoded.role;
		if (role == 'ADMIN' || role == 'FEJLESZTO' || role == 'SUPERVISOR' || role == 'ALSUPERVISOR') {
			this.joggomb = true;
		}
	}

	setVoucher() {
		if (this.permission == 'SUPERVISOR' || this.permission == 'ALSUPERVISOR' || this.permission == 'ADMIN' || this.permission == 'FEJLESZTO') {
			return true;
		}
		return false;

	}

	public hasError = (controlName: string, errorName: string) => {
		return this.form.controls[controlName].hasError(errorName);
	};


	applyFilter(filterValue: string) {
		this.events.filter = filterValue.trim().toLowerCase();
	}

	sample(eventId) {
		const modalRef = this.modalService.open(BItemComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.id = this.userID;
		modalRef.componentInstance.eventId = eventId;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	getDecodedAccessToken(token: string): any {
		try {
			return jwt_decode(token);
		} catch (Error) {
			return null;
		}
	}

	isSelected(row) {
		return this.userDetail.event && this.userDetail.event.find(x => {
			return x === row.id;
		});
	}

	userPermission() {
		const modalRef = this.modalService.open(UserPermisComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.id = this.userID;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	check($event, element) {
		if (!this.userDetail.event) {
			this.userDetail.event = [];
		}
		if ($event.checked) {
			this.userDetail.event.push(element.id);
		} else {
			this.userDetail.event = this.userDetail.event.filter(event => {
				return element.id !== event;
			});
		}
	}

	userEvents() {
		const modalRef = this.modalService.open(EventAttComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.userId = this.userID;
		// modalRef.componentInstance.permission = this.permission;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	userParking() {
		const modalRef = this.modalService.open(UserParkingComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.id = this.userID;
		modalRef.componentInstance.permission = this.permission;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	userPasses() {
		const modalRef = this.modalService.open(UserPassesComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.id = this.userID;
		modalRef.componentInstance.permission = this.permission;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	userBracelets() {
		const modalRef = this.modalService.open(UserBraceletsComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.id = this.userID;
		modalRef.componentInstance.permission = this.permission;
		modalRef.result.then(() => {
			this.getData();
		}).catch(() => {
		});
	}

	getAvailableRoles() {
		this.userService.getAvailableRoles().subscribe((res) => {
			this.availableRoles$.next(res.body);
		});
	}

	save() {
		const birth = moment(this.form.controls['birthDate'].value).format('YYYY-MM-DD');
		this.form.controls['birthDate'].setValue(birth);
		this.form.controls['eventIds'].setValue(this.userDetail.event);
		const formData = new FormData();
		formData.append('email', this.form.controls['email'].value);
		// formData.append('eventIds', this.form.controls['eventIds'].value);
		formData.append('firstname', this.form.controls['firstname'].value);
		formData.append('lastname', this.form.controls['lastname'].value);
		formData.append('roleId', this.form.controls['roleId'].value);
		formData.append('password', this.form.controls['password'].value);
		formData.append('birthDate', birth);
		formData.append('birthPlace', this.form.controls['birthPlace'].value);
		formData.append('motherName', this.form.controls['motherName'].value);
		formData.append('eventIds', this.form.controls['eventIds'].value);
		if (this.image) {
			formData.append('profileImage', this.image);
		}
		else {
			formData.append('profileImage', dataURLtoFile(this.url, 'file.png'));
		}
		if (this.form.controls['nickName'].value) {
			formData.append('nickName', this.form.controls['nickName'].value);
		}
		if (this.userID == 'new') {
			this.userService.newUser(formData).subscribe((res) => {
					if (res.status == 200) {
						this.toastr.success('A felhasználót sikeresen hozzáadta', '');
						this.router.navigate(['/users']);
					} else {
						this.toastr.error('Hiba történt', '');
					}
				}, error => {
					this.toastr.error(error.error.message, '');
				}
			);
		} else {
			this.userService.putUser(this.userID, formData).subscribe((res) => {
					if (res.status == 200) {
						this.toastr.success('A felhasználó adatait sikeresen frissítette!', '');
						this.getData();
					} else {
						this.toastr.error('HIBA', '');
					}
				}, (error => {
					this.toastr.error(error.error.message, '');
				})
			);
		}
	}
}
